import * as TelemetryDataAccess from "./TelemetryDataAccess";
import TelemetryException, { errorMsg } from "./TelemetryException";

export type Telemetry = {
  feature: string;
  action: string;
  action_meta: string;
  lo_uuid: string;
  slide_uuid?: string;
  student_id: number;
  course_id: number;
  student_session: string;
  player_version: string;
  autoplay: boolean;
  volume_percent: number;
  mute: boolean;
  playback_speed: number;
  video_resolution: string;
  player_modality: string;
  network_speed_mbps?: number;
  media_time?: number;
  fullscreen: boolean;
  closed_captions: string;
};

type TelemetryModel = {
  save(): Promise<Telemetry>;
};

const telemetryModel = (telemetry: Telemetry): Telemetry & TelemetryModel => {
  const {
    course_id,
    feature,
    action,
    action_meta,
    lo_uuid,
    slide_uuid,
    student_id,
    student_session,
    player_version,
    autoplay,
    volume_percent,
    mute,
    playback_speed,
    video_resolution,
    player_modality,
    network_speed_mbps,
    media_time,
    fullscreen,
    closed_captions,
  } = telemetry;

  const save = async (): Promise<Telemetry> => {
    try {
      return await TelemetryDataAccess.store(telemetry);
    } catch (error) {
      throw new TelemetryException(`${errorMsg}: ${error}`);
    }
  };

  return {
    save,
    course_id,
    feature,
    action,
    action_meta,
    lo_uuid,
    slide_uuid,
    student_id,
    student_session,
    player_version,
    autoplay,
    volume_percent,
    mute,
    playback_speed,
    video_resolution,
    player_modality,
    network_speed_mbps,
    media_time,
    fullscreen,
    closed_captions,
  };
};

export default telemetryModel;
